"use client";

import type {
  BrandPageFragment,
  CampaignFragment,
  CategoryPageFragment,
  DesignerPageFragment,
} from "@server/gql/graphql";
import type { Dispatch, SetStateAction } from "react";
import { createContext } from "react";
import type { Image, Product, Variant } from "types";

import type { Market } from "@features/market/config/i18n-config";
import { getDefaultMarket } from "@features/market/config/market-config";

export type ProductCardContextProps = {
  market: Market;
  locale?: string;
  product?: Product | Variant;
  pageData?:
    | CampaignFragment
    | BrandPageFragment
    | CategoryPageFragment
    | DesignerPageFragment
    | null;
  hideHoverImage?: boolean;
  hideStock?: boolean;
  isDense?: boolean;
  primaryImage?: Image;
  hoverImage?: Image;
  hoverImageHasLoaded?: boolean;
  setHoverImageHasLoaded?: Dispatch<SetStateAction<boolean>>;
  onRemove?: () => void;
  isEager?: boolean;
};

export const ProductCardContext = createContext<ProductCardContextProps>({
  market: getDefaultMarket(),
});
